import React from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';

export default function FinalThoughts() {
  return (
    <div className="space-y-8">
      <PlaybookSection
        title="Final Thoughts"
        icon={<SparklesIcon className="h-7 w-7 text-primary-light" />}
        heading="Reflections and next steps"
      >
        <PlaybookCard>
          <p className="text-lg text-gray-200">
            Mastering the art of data storytelling is a powerful skill that can transform how you communicate insights and drive change in your organization. Remember, the goal is not just to present data, but to create compelling narratives that inspire action and drive meaningful outcomes. By following this playbook, you'll be able to effectively link data to business outcomes, craft engaging stories, and present your findings with impact.
          </p>
        </PlaybookCard>
      </PlaybookSection>
    </div>
  );
} 